import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-slash",
  "use": "various-slash-usage",
  "viewBox": "0 0 8 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 16\" id=\"various-slash\"><path d=\"M6.6 0l-.2.2-6.4 14v1.6l.2.2h1.2l.2-.2L8 1.8V.2L7.8 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol